export const environment = {
  production: true,
  apiRoot: '/desira-api/v1',
  graphqlUri: '/graphql'
};
